import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiSelect = {
  defaultProps: { displayEmpty: true, MenuProps: { sx: { mt: '4px' } } },
  styleOverrides: { select: { height: 'auto', minHeight: 'auto' } },
} satisfies Components<Theme>['MuiSelect'];
